export default __webpack_public_path__ + "static/media/EcommerceServicesLebenswerkBusinessManagement5.7cbc76f7.png";